import { useEffect } from "react"
import { useActsStore } from "../../store/useActsStore"
import useSfx from "../../utils/useSfx"


export default function AmbianceActeFour() {
    const currentActId = useActsStore((s) => s.getCurrentActId())

    const isActe4 = currentActId === 3

    const fogNoise = useSfx("/audio/sfx/ambiance-acte-four.mp3", true)
    const alienNoiseOne = useSfx("/audio/sfx/noise-one.mp3", false)
    const alienNoiseTwo = useSfx("/audio/sfx/noise-two.mp3", false)


    useEffect(() => {
        if (!isActe4){
            fogNoise.targetVolume.current = 0
            return
        }

        if (fogNoise.loadedRef.current && isActe4) {
            fogNoise.targetVolume.current = 0.5
            if (!fogNoise.soundRef.current?.isPlaying) {
                fogNoise.soundRef.current?.play(0)
            }
        }

        let cancelled = false
        let timeoutOne = null
        let timeoutTwo = null


        const scheduleNoiseOne = () => {
            const delay = Math.floor(Math.random() * (30000 - 15000) + 15000)

            timeoutOne = setTimeout(() => {
                if (cancelled) return
                if (!alienNoiseOne.loadedRef.current) return

                alienNoiseOne.targetVolume.current = 0.1
                alienNoiseOne.soundRef.current?.play(0)

                scheduleNoiseOne()
            }, delay)
        }


        const scheduleNoiseTwo = () => {
            const delay = Math.floor(Math.random() * (30000 - 15000) + 15000)

            timeoutTwo = setTimeout(() => {
                if (cancelled) return
                if (!alienNoiseTwo.loadedRef.current) return

                alienNoiseTwo.targetVolume.current = 0.1
                alienNoiseTwo.soundRef.current?.play(0)

                scheduleNoiseTwo()
            }, delay)
        }

        scheduleNoiseOne()
        scheduleNoiseTwo()

        return () => {
            cancelled = true
            if (timeoutOne) clearTimeout(timeoutOne)
            if (timeoutTwo) clearTimeout(timeoutTwo)
        }
    }, [isActe4])


    return null
}